<section class="card card-border bg-base-100">
  <div class="card-body gap-4 p-4 sm:p-5">
    <div class="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h3 class="card-title text-base">
          {{ 'Customer refusal outcome' | translate }}
        </h3>
        <p class="mt-1 text-sm text-base-content/70">
          {{ outcome().reasonText }}
        </p>
      </div>
      <button type="button" class="btn btn-sm btn-ghost" (click)="refresh.emit()">
        {{ 'Refresh' | translate }}
      </button>
    </div>

    <dl class="grid gap-3 text-sm sm:grid-cols-2">
      <div>
        <dt class="text-base-content/60">{{ 'Refused' | translate }}</dt>
        <dd class="font-medium">{{ outcome().refusedAtUtc | date: 'medium' }}</dd>
      </div>
      <div>
        <dt class="text-base-content/60">{{ 'Returned' | translate }}</dt>
        <dd class="font-medium">{{ outcome().returnedAtUtc | date: 'medium' }}</dd>
      </div>
    </dl>

    @if (showWallet()) {
      @if (outcome().outcome === 'codNoRefund') {
        <div role="status" class="alert alert-soft alert-info text-sm">
          <span>{{
            'No refund is due because payment was Cash on Delivery and no value was collected.'
              | translate
          }}</span>
        </div>
      } @else {
        <div class="rounded-box bg-base-200 p-4">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <h4 class="font-semibold">{{ 'Wallet refund' | translate }}</h4>
            <span [class]="statusClass(outcome().walletStatus)">
              {{ statusLabel(outcome().walletStatus) | translate }}
            </span>
          </div>
          <p class="mt-2 text-xl font-semibold">
            {{ outcome().customerRefundAmount }} {{ outcome().currency }}
          </p>
          <p class="mt-1 text-xs text-base-content/60">
            {{ 'Includes original shipping' | translate }}:
            {{ outcome().originalShippingRefundAmount }} {{ outcome().currency }}
          </p>
          @if (outcome().walletCreditId) {
            <p class="mt-2 break-all font-mono text-xs text-base-content/60">
              {{ 'Wallet credit ID' | translate }}: {{ outcome().walletCreditId }}
            </p>
          }
          @if (walletLink()) {
            <a [routerLink]="walletLink()" class="btn btn-sm mt-3">
              {{ 'View Wallet' | translate }}
            </a>
          }
        </div>
      }
    }

    @if (showSellerLiability()) {
      <div class="rounded-box bg-base-200 p-4">
        <div class="flex flex-wrap items-center justify-between gap-2">
          <h4 class="font-semibold">{{ 'Seller return liability' | translate }}</h4>
          <span [class]="statusClass(outcome().sellerLiabilityStatus)">
            {{ statusLabel(outcome().sellerLiabilityStatus) | translate }}
          </span>
        </div>
        <p class="mt-2 text-xl font-semibold">
          {{ outcome().sellerLiabilityAmount }} {{ outcome().currency }}
        </p>
        <dl class="mt-3 grid gap-3 text-sm sm:grid-cols-2">
          <div>
            <dt class="text-base-content/60">{{ 'Payout adjusted' | translate }}</dt>
            <dd class="font-medium">
              {{ outcome().sellerAdjustedAmount ?? '—' }}
              @if (outcome().sellerAdjustedAmount !== null) {
                {{ outcome().currency }}
              }
            </dd>
          </div>
          <div>
            <dt class="text-base-content/60">{{ 'Recoverable debt' | translate }}</dt>
            <dd class="font-medium">
              {{ outcome().sellerDebtAmount ?? '—' }}
              @if (outcome().sellerDebtAmount !== null) {
                {{ outcome().currency }}
              }
            </dd>
          </div>
        </dl>
        @if (outcome().sellerLiabilityPostingId) {
          <p class="mt-2 break-all font-mono text-xs text-base-content/60">
            {{ 'Accounting posting ID' | translate }}:
            {{ outcome().sellerLiabilityPostingId }}
          </p>
        }
      </div>
    }

    @if (showOperations()) {
      <details class="collapse collapse-arrow border border-base-300">
        <summary class="collapse-title text-sm font-semibold">
          {{ 'Operational references' | translate }}
        </summary>
        <dl
          class="collapse-content grid gap-2 break-all font-mono text-xs sm:grid-cols-2"
        >
          <div>
            <dt>Finalization</dt>
            <dd>{{ outcome().finalizationId }}</dd>
          </div>
          <div>
            <dt>Route</dt>
            <dd>{{ outcome().routeId }}</dd>
          </div>
          <div>
            <dt>Stop</dt>
            <dd>{{ outcome().stopId }}</dd>
          </div>
          <div>
            <dt>Recovery</dt>
            <dd>{{ outcome().recoveryId }}</dd>
          </div>
          <div>
            <dt>Driver</dt>
            <dd>{{ outcome().driverId }}</dd>
          </div>
          @if (outcome().paymentAttemptId) {
            <div>
              <dt>Payment attempt</dt>
              <dd>{{ outcome().paymentAttemptId }}</dd>
            </div>
          }
        </dl>
      </details>
    }
  </div>
</section>
